import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const CancellationPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white py-20 px-4">
      <div className="container mx-auto max-w-4xl">
        {/* Navigation */}
        <div className="mb-8">
          <Button
            variant="outline"
            onClick={() => window.location.href = '/'}
            className="border-golden/20 text-golden hover:bg-golden hover:text-black transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
        {/* Header */}
        <div className="text-center mb-12">
          <Badge className="bg-golden/10 text-golden border-golden/20 mb-4">Legal</Badge>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-golden">
            Cancellation and Refunds Policy
          </h1>
          <p className="text-gray-400">Upper Circuit Stocks by Chirag Rathod</p>
          <p className="text-sm text-gray-500 mt-2">Last updated: October 2024</p>
        </div>

        <Card className="bg-gray-900/50 border-golden/20 mb-8">
          <CardHeader>
            <CardTitle className="text-golden">1. Monthly Subscription Services</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <h4 className="font-semibold text-white">1.1 Cancellation Policy</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Monthly subscriptions cannot be cancelled once availed</li>
              <li>• No Cancellation requests shall be entertained in any case and manner</li>
              <li>• Cancelled subscriptions remain active until the end of the current billing cycle</li>
              <li>• No automatic renewal occurs after cancellation</li>
            </ul>

            <h4 className="font-semibold text-white">1.2 Refund Policy</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• <strong>Payment once done will not be refunded</strong></li>
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-gray-900/50 border-golden/20 mb-8">
          <CardHeader>
            <CardTitle className="text-golden">2. Automated Alert Services</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <h4 className="font-semibold text-white">2.1 Trading Day Subscriptions</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Alert services are sold for specific trading days (1, 3, or 5 trading days)</li>
              <li>• Trading days exclude weekends and Indian stock market holidays</li>
              <li>• Service automatically expires after the specified trading days</li>
              <li>• No cancellation allowed once the first trading day has commenced</li>
            </ul>

            <h4 className="font-semibold text-white">2.2 Refund Policy for Alerts</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• <strong>Before First Trading Day:</strong> 100% refund available</li>
              <li>• <strong>After First Trading Day:</strong> No refunds due to the nature of intraday signals</li>
              <li>• Technical issues on our end may qualify for partial refunds</li>
              <li>• Market closure due to unforeseen circumstances extends validity by equivalent days</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-gray-900/50 border-golden/20 mb-8">
          <CardHeader>
            <CardTitle className="text-golden">3. Workshop Purchases</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <h4 className="font-semibold text-white">3.1 Digital Workshop Content</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Workshop purchases are final once access is granted</li>
              <li>• Lifetime access is provided to purchased workshop content</li>
              <li>• No refunds after workshop materials have been accessed</li>
              <li>• Technical issues preventing access will be resolved or refunded</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-gray-900/50 border-golden/20 mb-8">
          <CardHeader>
            <CardTitle className="text-golden">4. General Terms</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <h4 className="font-semibold text-white">4.1 Refund Process</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Refund requests must include order ID and reason for refund</li>
              <li>• All refunds are processed to the original payment method</li>
              <li>• Processing time: 5-7 business days for most payment methods</li>
              <li>• Email notifications sent for all refund status updates</li>
            </ul>

            <h4 className="font-semibold text-white">4.2 Non-Refundable Items</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• Services already consumed or used extensively</li>
              <li>• Losses incurred due to trading decisions based on our analysis</li>
              <li>• Market volatility or unexpected market events</li>
              <li>• User's inability to execute recommended trades</li>
            </ul>

            <h4 className="font-semibold text-white">4.3 Dispute Resolution</h4>
            <ul className="text-gray-300 space-y-2 ml-4">
              <li>• All disputes will be handled through direct communication first</li>
              <li>• Escalated disputes subject to Indian jurisdiction and laws</li>
              <li>• Good faith efforts will be made to resolve all customer concerns</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-golden/5 border-golden/30">
          <CardHeader>
            <CardTitle className="text-golden">Contact for Refunds</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-semibold text-white mb-2">Email Support</h4>
                <p className="text-gray-300">chiragbrathod1988@gmail.com</p>
              </div>
              <div>
                <h4 className="font-semibold text-white mb-2">Response Time</h4>
                <p className="text-gray-300">Within 24 hours on business days</p>
              </div>
            </div>
            <div className="mt-4 p-4 bg-black/30 rounded-lg">
              <p className="text-sm text-gray-400">
                <strong>Disclaimer:</strong> All trading and investment services carry risk. Past performance does not guarantee future results. 
                Our analysis and recommendations are for educational purposes only and should not be considered as financial advice.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CancellationPolicy;